<template>
  <span>
    <section class="py-14 lg:pt-32 lg:pb-24 bg-top bg-no-repeat bg-cover" style="background-image: url('/img/thank-you.jpg');">
        <div class="max-w-3xl mx-auto flex flex-col items-center px-8 lg:px-0 text-center">
            <img class="w-full"  src="/img/woulien-font-white.svg">
            <p class="text-white mt-5 text-lg">for signing up for
              <strong>
              <a :href="`campaigns/`+getParentId()">{{getParentName()}}</a>
            </strong></p>
            <h2 class="text-white font-medium mt-10">Take the first step towards making an impact!</h2>
            <div class="flex flex-col lg:flex-row w-full mt-8 space-y-3 lg:space-x-5 lg:space-y-0">
                <div class="w-full mb-1 lg:w-1/2">
                    <a  @click="openDonationModal" id="my-donate-button" href="#" class="bg-pink hover:bg-pink-700 text-white w-full block py-3 px-7 font-medium uppercase focus:outline-none focus:outline-none  focus:ring-pink-200">Donate Now</a>

                     <make-donation-widget slot="body" :campaign-id="campaignId"  :campaign="campaign" :key="`gen_don_`+campaignId"></make-donation-widget>

                </div>
                <div class="w-full mb-1 lg:w-1/2">
                    <a href="/active-campaigns" class="bg-blue hover:bg-blue-700 text-white w-full block py-3 px-7 font-medium uppercase focus:outline-none focus:outline-none  focus:ring-blue-200">Go To Your Dashboard</a>
                </div>
            </div>
        </div>
    </section>

    <section class="bg-white py-10">
        <div class="max-w-3xl mx-auto flex flex-col items-center px-8 lg:px-0 text-center">
            <h2 class="font-bold mb-5 text-xl lg:text-2xl">Did you know that you get a FREE fundraising webpage?</h2>
            <p>It’s TRUE! Customize your free fundraising web page to make it unique and represent your initiative. You can add text, pictures, even create a video letting those within your community know what you are doing. Inspire your audience and enhance the success of your campaign!</p>
            <div class="flex flex-col lg:flex-row w-full mt-8 space-y-3 lg:space-x-5 lg:space-y-0">
                <div class="w-full mb-1 lg:w-1/2">
                    <a :href="`/edit-campaign/`+campaignId" class="bg-blue hover:bg-blue-600 text-white w-full block py-3 px-7 font-medium uppercase">Customize My Page</a>
                </div>
                <div class="w-full mb-1 lg:w-1/2">
                    <a :href="`/campaigns/`+campaignId" class="bg-pink hover:bg-pink-600 text-white w-full block py-3 px-7 font-medium uppercase">View Your Page</a>
                </div>
            </div>
        </div>
    </section>
  </span>
</template>

<script>
  import MakeDonationWidget from "../make-donation/MakeDonationWidget";

export default {
    name: 'CampaignPage',
    components: {
      MakeDonationWidget,
    },
    props: {
      campaignId: {
        type: String,
        required: true,
      },

      myCampaign: {
        type: Object,
        required: false,
      },
    },

    data() {
      return {
        isVisible: true,
        campaign: this.myCampaign,
      }
    },

    created() {
      this.isLoading = true

      this.emitter.on('campaign-donation-update', (campaign) => {
        this.campaign = campaign
      })
  },
    methods: {
      openDonationModal() {
        this.emitter.emit('open-donation-modal');
      },
      getParentId() {
        if (this.campaign.parent) {
          return this.campaign.parent.id
        }
        return this.campaign.id
      },
      getParentName() {
        if (this.campaign.parent) {
          return this.campaign.parent.name
        }
        return this.campaign.name
      },
    },

  }
</script>
